var _ = require('underscore');
var $ = require('jquery');
var TorsoFormView = require('backbone-torso/modules/FormView');
var shownEntriesTemplate = require('./shownEntriesTemplate.hbs');

/**
 * View to handle changing the number of visible items per page for
 * BrecTable.
 *
 * @class ShowEntriesView
 * @constructor
 * @param options {Object} passed in options and the tableState from the parent view.
 *   @param options.tableState {Torso.Cell} the shared state of the widget (filters, search, paging, fetching... etc.).
 *   @param [options.filterOptions=[5, 10, 25, 50]] {Number[]} the entriesPerPage options to present to the user.
 *   @param [options.ariaControls=''] {String} the id of the table associated with this widget.
 */
module.exports = TorsoFormView.extend({
  className: 'brec-table__showing-entry',
  attributes: function() {
    return {
      'aria-controls': this._ariaControls,
      'aria-label': $.i18n.prop('widget.showEntries.arialLabel')
    };
  },
  template: shownEntriesTemplate,

  filterOptions: [5, 10, 25, 50],

  prepareFields: {
    'tableState': '_tableState',
    'ariaControls': '_ariaControls'
  },

  /**
   * @method constructor
   * @param options {Object} passed in options and the tableState from the parent view.
   *   @param options.tableState {Torso.Cell} the shared state of the widget (filters, search, paging, fetching... etc.).
   *   @param [options.filterOptions=[5, 10, 25, 50]] {Number[]} the entriesPerPage options to present to the user.
   *   @param [options.ariaControls=''] {String} the id of the table associated with this widget.
   * @override
   */
  constructor: function(options) {
    var defaultOptions = {
      tableState: null,
      filterOptions: this.filterOptions,
      ariaControls: '',
      totalEntries: null
    };
    options = _.defaults({}, options, defaultOptions);
    this._ariaControls = options.ariaControls;

    TorsoFormView.apply(this, arguments);

    this._tableState = options.tableState;

    this.set('filterOptions', options.filterOptions);

    // Used for testing to override our total entries when
    // we are not making an actual ajax call.
    if (options.totalEntries) {
      this._tableState.set('totalEntries', options.totalEntries);
    }

    this._pullPageInfo();

    this.listenTo(this.model, 'change:entriesPerPage', this._pushEntriesPerPage);
    this.listenTo(this._tableState, 'change:entriesPerPage change:totalEntries change:page', this._pullPageInfo);
    this.listenTo(this._tableState, 'change:totalEntries', this.render);
    this.listenTo(this.viewState, 'change:minEntry change:maxEntry', this.render);

    this._pushEntriesPerPage();
  },

  /**
   * Helper method that sets the total number of entries, page and entries per page locally.  From those it calculates
   * the min/max entries for the display.
   * @method _pullPageInfo
   * @private
   */
  _pullPageInfo: function() {
    var totalEntries = this._tableState.get('totalEntries');
    var page = this._tableState.get('page');
    var entriesPerPage = this._tableState.get('entriesPerPage');

    var minEntry = ((page - 1) * entriesPerPage) + 1; // to deal with base 0 / base 1 conversions.
    var maxEntry = Math.min(totalEntries, page * entriesPerPage);
    minEntry = Math.min(minEntry, maxEntry);
    this.set({
      minEntry: minEntry,
      maxEntry: maxEntry
    });

    // Convert to string for select option matching.
    if (_.isNumber(entriesPerPage)) {
      entriesPerPage = entriesPerPage.toString();
    }
    this.model.set('entriesPerPage', entriesPerPage);
  },

  /**
   * Let the rest of the table view widget know that the entries per page changed.
   * @method _pushEntriesPerPage
   * @private
   */
  _pushEntriesPerPage: function() {
    var entriesPerPage = this.model.get('entriesPerPage');
    // Make sure that entries per page is a Number when set on the table state.
    if (_.isFinite(entriesPerPage)) {
      entriesPerPage = Number(entriesPerPage);
    }

    var currentEntriesPerPage = this._tableState.get('entriesPerPage');
    // Only reset page to 1 if the entriesPerPage has changed.
    if (currentEntriesPerPage !== entriesPerPage) {
      this._tableState.set('page', 1);
      this._tableState.set('entriesPerPage', entriesPerPage);
    }
  }
});
